<template>
    <v-text-field
        class="filter"
        rounded
        outlined
        dense
        v-bind="$attrs"
        v-on="$listeners"
        @keydown="$attrs.type === 'number' ? preventNonNumericalInput($event) : false"
    >
    </v-text-field>
</template>

<script>
export default {
    name: 'BFilterInput',
    props: {},
    data() {
        return {};
    },
    computed: {},
    created() {},
    methods: {
        preventNonNumericalInput(e) {
            e = e || window.event;
            const allowedCharacters = [
                '.',
                ',',
                'Backspace',
                'ArrowUp',
                'ArrowDown',
                'ArrowLeft',
                'ArrowRight',
                'Enter',
            ];
            if (!e.key.match(/^[0-9]+$/) && !allowedCharacters.includes(e.key)) e.preventDefault();
        },
    },
};
</script>

<style lang="scss">
.v-input.filter {
    .v-text-field__details {
        display: none;
    }
    .v-input__control {
        .v-input__slot {
            margin-bottom: 0;
        }
    }
}
</style>
